export type PgProvider = 'inicis' | 'pay-letter' | 'paypal';

export type PaymentRegion = 'kr' | 'global';

const normalizePgProvider = (provider?: string): PgProvider | null => {
  const normalizedProvider = provider?.trim().toLowerCase();

  if (normalizedProvider === 'pay-letter') {
    return 'pay-letter';
  }

  if (normalizedProvider === 'paypal') {
    return 'paypal';
  }

  if (normalizedProvider === 'inicis') {
    return 'inicis';
  }

  return null;
};

export const getPaymentRegion = (country?: string | null): PaymentRegion => {
  if (!country) {
    return 'kr';
  }

  return country.trim().toUpperCase() === 'KR' ? 'kr' : 'global';
};

export const getPgProvider = (country?: string | null): PgProvider => {
  const region = getPaymentRegion(country);
  const provider =
    region === 'kr'
      ? normalizePgProvider(import.meta.env.REACT_APP_KR_PG_PROVIDER)
      : normalizePgProvider(import.meta.env.REACT_APP_GLOBAL_PG_PROVIDER);

  if (provider) {
    return provider;
  }

  return region === 'kr' ? 'pay-letter' : 'paypal';
};

export const getOneTimePaymentLaunchPath = (
  country?: string | null
): '/payment/inicis' | '/payment/pay-letter' | '/payment/paypal' => {
  const provider = getPgProvider(country);

  if (provider === 'pay-letter') {
    return '/payment/pay-letter';
  }

  if (provider === 'paypal') {
    return '/payment/paypal';
  }

  return '/payment/inicis';
};
